<template>
  <b-container v-if="!loading" class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Zákazníci
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Stav:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="state"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="filter.state"
                      :options="[
                        { id: 1, name: 'Aktívny' },
                        { id: 0, name: 'Neaktívny' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          filter.state = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
      <div v-if="$root.user.isAdmin" class="ml-3">
        <b-dropdown
          class="mr-1"
          menu-class="dropdown-menu-animated"
          right
          size="lg"
          variant="secondary"
        >
          <template #button-content>
            <b-icon icon="gear" />
          </template>
          <b-dropdown-item-button @click="openAddCustomerModal({ edit: true })">
            <b-icon class="mr-1" icon="pencil-square" />
            Upraviť
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="exportCustomers">
            <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
            Exportovať
          </b-dropdown-item-button>
          <b-dropdown-item-button class="text-danger" @click.prevent="remove">
            <b-icon icon="trash" class="mr-1" />
            Vymazať
          </b-dropdown-item-button>
        </b-dropdown>
        <b-btn
          v-if="$root.user.isAdmin"
          class="text-uppercase"
          size="lg"
          variant="primary"
          @click="openAddCustomerModal"
        >
          <b-icon class="mr-1" icon="plus" scale="1.5x" />
          Nový zákazník
        </b-btn>
      </div>
    </div>
    <add-customer ref="customerForm" @saved="fetchData" />
    <b-row class="flex-grow-1" style="min-height: 1px">
      <list ref="list" :list="list" @loaded="fetchData" />
      <transition mode="out-in" name="fadeShort">
        <router-view :key="$route.params.id" />
      </transition>
    </b-row>
  </b-container>
</template>
<script>
import { saveAs } from 'file-saver'
import alerts from '@/mixins/alerts'
import List from './List'
import AddCustomer from './Add'
import InputFilter from '@/components/InputFilter'
import Selectbox from '@/components/inputs/Selectbox'

export default {
  components: {
    List,
    AddCustomer,
    InputFilter,
    Selectbox,
  },
  mixins: [alerts],
  data() {
    return {
      loading: false,
      list: [],
      count: null,
      filterOptions: {
        orderBy: { column: 'name' },
        sortable: ['name', 'customer_groups.name', 'city'],
        searchIn: ['customers.name', 'customer_groups.name', 'city'],
        headings: {
          name: 'Názov spoločnosti',
          'customer_groups.name': 'Skupina',
          city: 'Mesto',
        },
      },
      filter: {
        state: null,
      },
    }
  },
  watch: {
    $route() {
      if (!this.$route.params.id) {
        this.gotoFirst()
      }
    },
  },
  methods: {
    openAddCustomerModal({ edit = false }) {
      this.$refs.customerForm.edit = edit
      this.$nextTick(() => {
        this.$root.$emit('modal-show', 'add-customer')
      })
    },
    remove() {
      this.$swal({
        title: 'Ste si istý?',
        html: 'Skutočne chcete odstrániť túto spoločnosť?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .post(`customers/${this.$route.params.id}/delete`)
            .then((res) => {
              this.$swal({
                type: 'success',
                position: 'top',
                showCloseButton: true,
                text: res.data.message,
                timer: 5000,
              })
              this.resetFilter()
              this.$route.params.id = null
            })
        }
      })
    },
    fetchData(silent, $state) {
      this.loading = !silent
      this.$api
        .get('customers/get_list', {
          params: this.$refs.filter.params,
        })
        .then((res) => {
          this.count = res.data.total
          if (res.data.rows.length) {
            this.$refs.filter.params.startAt = this.list.length + 20
            this.list = this.list.concat(res.data.rows)
            if ($state) {
              $state.loaded()
            }
          } else {
            $state.complete()
          }
          if (!this.$route.params.id) {
            this.gotoFirst()
          }
          if (!silent) {
            this.loading = false
          }
        })
    },
    gotoFirst() {
      this.$router.push({
        name: 'customerView',
        params: { id: this.list[0] ? this.list[0].id : null },
      })
    },
    search() {
      this.list = []
      this.$refs.filter.params.startAt = 0
      this.$nextTick(() => {
        this.$refs.list.reset()
      })
    },
    resetFilter() {
      this.search()
    },
    exportCustomers() {
      this.toastInfo('Pripravujem export...')
      this.$api
        .get('customers/export', {
          params: {
            query: this.$refs.filter.value,
            searchIn: this.$refs.filter.params.searchIn,
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((response) => {
          saveAs(new Blob([response.data]), 'zakaznici.xlsx')
          this.toastSuccess('Export pripravený', { timer: 5000 })
        })
        .catch(() => {
          this.toastDanger('Chyba pri exportovaní', { timer: 5000 })
        })
    },
  },
}
</script>
